import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { createMediaQueryString, MIN_WIDTH_BREAKPOINTS } from "@faire/web--source/common/media";
export var Media2Strings = /*#__PURE__*/ function() {
    "use strict";
    function Media2Strings() {
        var minWidthBreakpoints = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : MIN_WIDTH_BREAKPOINTS;
        _class_call_check(this, Media2Strings);
        this.minWidthBreakpoints = minWidthBreakpoints;
        this.canHover = "@media (hover: hover)";
    }
    _create_class(Media2Strings, [
        {
            key: "responsiveBreakpoints",
            get: function get() {
                return {
                    mobile: {
                        max: "".concat(this.minWidthBreakpoints.TABLET - 1, "px")
                    },
                    tablet: {
                        min: "".concat(this.minWidthBreakpoints.TABLET, "px"),
                        max: "".concat(this.minWidthBreakpoints.DESKTOP - 1, "px")
                    },
                    desktop: {
                        min: "".concat(this.minWidthBreakpoints.DESKTOP, "px"),
                        max: "".concat(this.minWidthBreakpoints.XLARGE - 1, "px")
                    },
                    xlarge: {
                        min: "".concat(this.minWidthBreakpoints.XLARGE, "px"),
                        max: "".concat(this.minWidthBreakpoints.XXLARGE - 1, "px")
                    },
                    xxlarge: {
                        min: "".concat(this.minWidthBreakpoints.XXLARGE, "px")
                    },
                    tabletAndBelow: {
                        max: "".concat(this.minWidthBreakpoints.DESKTOP - 1, "px")
                    },
                    tabletAndAbove: {
                        min: "".concat(this.minWidthBreakpoints.TABLET, "px")
                    },
                    desktopAndAbove: {
                        min: "".concat(this.minWidthBreakpoints.DESKTOP, "px")
                    },
                    xLargeAndAbove: {
                        min: "".concat(this.minWidthBreakpoints.XLARGE, "px")
                    }
                };
            }
        },
        {
            key: "mobile",
            get: function get() {
                return createMediaQueryString(this.responsiveBreakpoints.mobile);
            }
        },
        {
            key: "tablet",
            get: function get() {
                return createMediaQueryString(this.responsiveBreakpoints.tablet);
            }
        },
        {
            key: "desktop",
            get: function get() {
                return createMediaQueryString(this.responsiveBreakpoints.desktop);
            }
        },
        {
            key: "xlarge",
            get: function get() {
                return createMediaQueryString(this.responsiveBreakpoints.xlarge);
            }
        },
        {
            key: "xxlarge",
            get: function get() {
                return createMediaQueryString(this.responsiveBreakpoints.xxlarge);
            }
        },
        {
            key: "tabletAndAbove",
            get: function get() {
                return createMediaQueryString(this.responsiveBreakpoints.tabletAndAbove);
            }
        },
        {
            key: "tabletAndBelow",
            get: function get() {
                return createMediaQueryString(this.responsiveBreakpoints.tabletAndBelow);
            }
        },
        {
            key: "desktopAndAbove",
            get: function get() {
                return createMediaQueryString(this.responsiveBreakpoints.desktopAndAbove);
            }
        },
        {
            key: "xLargeAndAbove",
            get: function get() {
                return createMediaQueryString(this.responsiveBreakpoints.xLargeAndAbove);
            }
        }
    ]);
    return Media2Strings;
}();
